module.exports = __webpack_public_path__ + "img/1577634655.4bd268fd.jpg";